import {
  AccountFeatureFlag,
  Vendor,
} from "@towersystems/roam-common/lib/generated-types";

// Determines if a vendor has access to a specific feature based on their feature flags
export const vendorCanAccessFeature = (
  feature: AccountFeatureFlag,
  currentVendor: Vendor
): boolean => {
  const maybeMatch = currentVendor?.featureFlags?.find(
    (f) => f.code === feature
  );

  if (!maybeMatch) {
    return true; // If the feature flag is not set, we assume access is allowed
  }

  return maybeMatch.enabled;
};
